import CsharpEnum from "./CsharpEnum";

export const templateDashboardTypes = {
  Full: {
    name: "templateDashboard.dashboardType.0",
    value: 0,
    icon: "mdi-monitor-dashboard",
  },
  SideAndMap: {
    name: "templateDashboard.dashboardType.1",
    value: 1,
    icon: "mdi-monitor-dashboard",
  },
  Node: {
    name: "templateDashboard.dashboardType.2",
    value: 2,
    icon: "mdi-monitor-dashboard",
  },
};

export function useSlotAndKeys(type) {
  switch (type) {
    case 0:
      return false;
    case 1:
      return true;
    case 2:
      return true;
    default:
      return true;
  }
}
export const globalWidgetTypes = [CsharpEnum.ModuleType.MASTERTIMEPICKER];
